import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IndividualRenewalService } from '../individual-renewal.service';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { Router } from '@angular/router';
import { SubmitQuestionnaireAnswersResponseModel } from '../../../model/submitQuestionnaireAnswersResponseModel';
import { QuestionnaireQuestionModel } from '../../../model/questionnaireQuestionModel';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { StorageService } from '../../../shared/security/StorageService';
import { ContentPageModel } from '../../../model/models';
import { SectionContentModel } from '../../../model/sectionContentModel';
import { SectionTextModel } from '../../../model/sectionTextModel';
import * as $ from 'jquery';

@Component({
  selector: 'app-individual-review-renewal',
  templateUrl: './individual-review-renewal.component.html',
  styleUrls: ['./individual-review-renewal.component.css']
})
export class IndividualReviewRenewalComponent implements OnInit {

  notifySubmitQuestionnaireAnswersSubscription: Subscription = new Subscription();
  notifyQuestionListSubscription: Subscription = new Subscription();
  submitQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = new SubmitQuestionnaireAnswersResponseModel();
  questions: Array<QuestionnaireQuestionModel> = [];
  startFunction: StartFunctionResponseModel = {};
  headerContent : SectionContentModel = new SectionContentModel;

  constructor(private individualRenewalService: IndividualRenewalService,
    private router: Router,
    private currentPageWatcher: CurrentPageWatcherService,
    private startFunctionService: StartFunctionService,
    private storage : StorageService) {

    this.startFunction = this.storage.getStartFunctionData();

    let textModel : SectionTextModel = new SectionTextModel();
    textModel.text="Please review the following information that you submitted for your renewal. If you need to make any changes click the Back button to reach the page you need to make changes for. After you have verified the information click the Continue button.";
    this.headerContent.textList.push(textModel);

    this.currentPageWatcher.sendHeaderContent(this.headerContent);


    this.notifySubmitQuestionnaireAnswersSubscription = this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().subscribe(submitQuestionnaireAnswersResp => {
      this.submitQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;
    });

    this.notifyQuestionListSubscription = this.individualRenewalService.getNotifyIndividualQuestionList().subscribe(questionListData => {
      this.questions = questionListData;
    });
  }

  ngOnInit() {
  }

  continue(){}
  goBack(){
    this.router.navigate(['/home']);
  }

}



// WEBPACK FOOTER //
// ./src/app/renewal/individual-renewal/individual-review-renewal/individual-review-renewal.component.ts